export default __webpack_public_path__ + "static/media/hht2_img02.ceacb179.png";